import React from "react";
import { FormattedMessage } from "react-intl";
import Anchor from "../Anchor";
import styles from "./styles.css";
const ID = "contacts";
function Contacts() {
    return (React.createElement("section", { id: ID, className: styles.container },
        React.createElement(Anchor, { id: ID, label: React.createElement(FormattedMessage, { id: "ContactUsTitle" }) }),
        React.createElement("p", null,
            React.createElement(FormattedMessage, { id: "ContactUsHelperText" }),
            " – ",
            React.createElement("a", { href: "mailto:mr.oleski1@gmail.com", target: "_blank", rel: "nofollow noopener", className: styles.email }, "mr.oleski1@gmail.com"))));
}
;
export default Contacts;
